import { useAuth } from "@/context/AuthContext";

// Returns a lookup(name) -> hex colour for a user (by name), or null if unknown.
export function useUserColor() {
  const { users } = useAuth();
  const map = {};
  (users || []).forEach((u) => { if (u?.name) map[u.name.toLowerCase()] = u.color; });
  return (name) => map[(name || "").toLowerCase()] || null;
}
